module.exports = "https://static.wmbcdn.com/uniweb/images/feb2d3191be89d986deff235444bf2db.svg";